import { cn, Tooltip, useSidebarRail } from "@nexxt/ui";
import { Search } from "lucide-react";
import { m } from "../paraglide/messages.js";
import { ShortcutKeys, shortcutKeys } from "./shortcut-keys";

// The button that opens ⌘K: wide in the sidebar; in the narrow sidebar an icon with its name in a tooltip; in the top
// bar (`compact`) an icon below `sm`, whose text stays for screen readers.

interface SearchButtonProps {
  onClick: () => void;
  compact?: boolean;
  className?: string;
}

export function SearchButton({ onClick, compact = false, className }: SearchButtonProps) {
  const rail = useSidebarRail();
  const button = (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex h-(--control-h) shrink-0 items-center gap-2 rounded-md border border-input bg-background text-left text-sm text-muted-foreground",
        rail ? "w-(--control-h) justify-center" : "px-2",
        compact && "min-w-(--control-h) justify-center sm:w-64 sm:justify-start",
        className,
      )}
    >
      <Search aria-hidden className="size-4 shrink-0" />
      <span className={cn(rail ? "sr-only" : "flex-1", compact && "sr-only sm:not-sr-only")}>
        {m.search_or_command()}
      </span>
      {!rail && (
        <span className={compact ? "hidden sm:inline-flex" : undefined}>
          <ShortcutKeys keys={shortcutKeys.palette} />
        </span>
      )}
    </button>
  );
  if (!rail) return button;
  return (
    <Tooltip
      content={
        <>
          {m.search_or_command()}
          <ShortcutKeys keys={shortcutKeys.palette} />
        </>
      }
    >
      {button}
    </Tooltip>
  );
}
